<div class="header"
    *ngIf="header"
    >{{header}}</div>
<div class="body">
    <ng-content></ng-content>
</div>
